import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-secure-layout",
  templateUrl: "./secure-layout.component.html",
  styleUrls: ["./secure-layout.component.scss"]
})
export class SecureLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
